import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import { compose } from "recompose";

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
        height: '10px'
    },
    paper: {
        position: 'absolute',
        width: '60%',
        [theme.breakpoints.down('sm')]: {
            height: '90%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    group: {
        flexDirection: 'row',
    },
    margin: {
        marginLeft: -(theme.spacing.unit * 4),
        marginTop: theme.spacing.unit * 3,
    },
    setMarginTop: {
        marginTop: `${theme.spacing.unit * 3}px`,
        margin: `${theme.spacing.unit}px`,
    },
    setMarginBottom: {
        marginBottom: `${theme.spacing.unit * 3}px`,
    },
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
});

function getModalStyle() {
    const top = 50;
    const left = 50;
    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    }
}

class CertFormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            mode: 'ADD',
            modalTitle: 'Add licenses & certifications',

            CertId: null,
            CertificationName: '',
            IssuingOrganization: '',
            CredentialId: '',
            CredentialUrl: '',
            CertificationsData: [],
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.open){
            this.cleanData()
        }

        if (nextProps.CertificationsData && nextProps.CertificationsData !== this.state.CertificationsData) {
            this.setState({
                CertificationsData: nextProps.CertificationsData,
            })
        }

        if(nextProps.CertificationsData && nextProps.CertId >= 0){
            this.setState({
                mode: 'EDIT',
                CertId: nextProps.CertId,
                CertificationName: nextProps.CertificationsData[nextProps.CertId].CertificationName,
                IssuingOrganization: nextProps.CertificationsData[nextProps.CertId].IssuingOrganization,
                CredentialId: nextProps.CertificationsData[nextProps.CertId].CredentialId,
                CredentialUrl: nextProps.CertificationsData[nextProps.CertId].CredentialUrl,
            })
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    handleSave = () => {
        const Certifications = {
            'CertificationName': this.state.CertificationName,
            'IssuingOrganization': this.state.IssuingOrganization,
            'CredentialId': this.state.CredentialId,
            'CredentialUrl': this.state.CredentialUrl
        };

        var tempData = this.state.CertificationsData;
        if (this.state.mode === 'ADD') {
            tempData.push(Certifications);
        }
        else if (this.state.mode === 'EDIT') {
            tempData[this.state.CertId] = Certifications;
        }

        this.props.handleCertData(tempData)
        this.handleClose()
    }

    handleClose = () => {
        this.props.close();
        this.cleanData()
    }

    handleDelete = () => {
        var tempData = this.state.CertificationsData;
        tempData.splice(this.state.CertId, 1)

        this.props.handleCertData(tempData)
        this.handleClose()
    }

    cleanData() {
        this.setState({
            open: false,
            mode: 'ADD',
            modalTitle: 'Add licenses & certifications',

            CertId: -1,
            CertificationName: '',
            IssuingOrganization: '',
            CredentialId: '',
            CredentialUrl: ''
        });
    }

    render() {
        const { classes } = this.props;

        return (
            <Paper>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography id="modal-title" style={{ fontSize: 40, zIndex: 2 }}>
                            {this.state.modalTitle}
                        </Typography>

                        <TextField
                            label="*Certification Name"
                            id="CertificationName"
                            value={this.state.CertificationName}
                            className={classes.textField}
                            onChange={this.handleChange('CertificationName')}
                        />

                        <TextField
                            label="*Issuing Organization"
                            id="IssuingOrganization"
                            value={this.state.IssuingOrganization}
                            className={classes.textField}
                            onChange={this.handleChange('IssuingOrganization')}
                        />

                        <TextField
                            label="Credential ID"
                            id="CredentialId"
                            value={this.state.CredentialId}
                            className={classes.textField}
                            onChange={this.handleChange('CredentialId')}
                        />

                        <TextField
                            label="Credential URL"
                            id="CredentialUrl"
                            value={this.state.CredentialUrl}
                            className={classes.textField}
                            onChange={this.handleChange('CredentialUrl')}
                        />

                        <div style={{ marginTop: '40px' }} />
                        <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave}>
                            Save
                        </Button>
                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                        {
                            this.state.mode === 'ADD' ? '' :
                                <Button variant="outlined" className={classes.button} style={{ float: 'right' }} onClick={this.handleDelete}>
                                    Delete
                            </Button>
                        }
                    </div>
                </Modal>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users } = state;

    return {
        user,
        users,
    };
}

CertFormComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(CertFormComponent);


// WEBPACK FOOTER //
// ./src/components/Profile/CertFormComponent.js